import React, { Fragment } from 'react';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import CardFooter from './CardFooter';
import Table from './Table';

const QUERY = gql`
    query($operatorId: String!) {
        portalEstablishments(operatorId: $operatorId) {
            id, 
            title,
            address {
                address,
                number,
                neighborhood
                city,
                state
            },
            phone,
            isActive,
            createdAt
        }
    }
`;

const Card = ({ operatorId }) => (
    <div className="card shadow">
        <div className="card-header border-0">
            <h3 className="mb-0">Estabelecimentos</h3>
        </div>
        <Query query={QUERY} variables={{ operatorId }}>
            {({ loading, error, data }) => {
                if (loading) return 'Loading...';
                if (error) {
                    return (
                        <div className="rounded-0 alert alert-warning m-0">
                            Não foi possível carregar a lista de estabelecimentos.
                        </div>
                    );
                }
                const { portalEstablishments } = data;
                return (
                    <Fragment>
                        <Table establishments={portalEstablishments} />
                    </Fragment>
                );
            }}
        </Query>
    </div>
);

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(Card);


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/Card.js